<template>
  <div class="webdatalist">
    <div class="showLargeScreenOnly">
      <div v-for="group in clearanceGroups">
        <f7-block-title v-if="!isEmpty(filteredUserAccounts[group.clearance])">{{group.label}}</f7-block-title>
        <f7-list media-list>
          <f7-list-group v-for="(group, key) in filteredUserAccounts[group.clearance]" :key="key">
            <f7-list-item :title="key" group-title></f7-list-item>
              <li v-for="data in group" :key="data.id">
                <div class="item-content boxRequest">
                  <div class="item-inner" @click="editAccountMember(data)">
                    <div class="item-title">{{ data.login }}</div>
                    <div class="item-subtitle">{{ data.active }}</div>
                  </div>
                  <div class="item-media">
                    <button class="button-swipe-out" @click="removeAccountMemberWeb(data)">
                      <i class="fa fa-times-circle button-delete" ></i>
                    </button>
                  </div>
                </div>
              </li>
            </f7-list-group>
          </f7-list>
      </div>
      </div>
      <div class="showSmallScreenOnly">
        <div v-for="group in clearanceGroups">
          <f7-block-title v-if="!isEmpty(filteredUserAccounts[group.clearance])">{{group.label}}</f7-block-title>
          <f7-list media-list>
            <f7-list-group v-for="(group, key) in filteredUserAccounts[group.clearance]" :key="key">
              <f7-list-item :title="key" group-title></f7-list-item>
                  <li v-for="data in group" :key="data.id" class="swipeout">
                    <div class="item-content boxRequest swipeout-content">
                      <div class="item-inner" @click="editAccountMemberMobile(data)">
                        <div class="item-title">{{ data.login }}</div>
                        <div class="item-subtitle">{{ data.active }}</div>
                      </div>
                    </div>
                    <div class="swipeout-actions-right">
                      <a class="swipeout-create action3" href="#" v-on:click="editAccountMemberMobile(data)">
                        Edit
                      </a>
                      <a class="swipeout-delete action4" href="#" v-on:click="removeAccountMember(data)" delete>
                        Remove
                      </a>
                    </div>
                  </li>
              </f7-list-group>
            </f7-list>
        </div>

      </div>
  </div>
</template>

<script>
import {loadPage} from '@/helpers/routing'

export default {
  name: 'AccountMembersList',
  props: ['userAccounts', 'filterBy'],
  data: () => {
    return {
      list: '0'
    }
  },
  computed: {
    filteredUserAccounts () {
      let that = this
      let result = {}
      result[3] = {}
      result[2] = {}
      result[1] = {}
      result[0] = {}
      if (this.filterBy) {
        for (var j in that.userAccounts) {
          for (var k in that.userAccounts[j]) {
            for (var i = 0; i < that.userAccounts[j][k].length; i++) {
              if (that.userAccounts[j][k][i].login.toLowerCase().includes(this.filterBy.toLowerCase())) {
                if (!result[j].hasOwnProperty(k)) {
                  result[j][k] = []
                }
                result[j][k].push(that.userAccounts[j][k][i])
              }
            }
          }
        }
        return result
      }
      /*
      for (var j in that.userAccounts) {
        that.userAccounts[j] = that.userAccounts[j].filter(x => x.clearance_directPayments === '') // TODO
        if (that.userAccounts[j].length === 0) {
          delete that.userAccounts[j]
        }
      }
      */
      return that.userAccounts
    },
    clearanceGroups () {
      return [
        {clearance: 1, label: 'Administrators'},
        {clearance: 2, label: 'Managers'},
        {clearance: 3, label: 'Users'},
        {clearance: 0, label: 'No Access'}
      ]
    }
  },
  methods: {
    onSwipeoutDeleted () {
      alert('deleted')
    },
    editAccountMember (data) {
      this.$engine.settings.set({currentAccountMember: data})
      // var formData = {
      //   'login': data.login,
      //   'status': data.status
      // }
      // this.$f7.formFromData('#EditAccountMemberForm', formData)
      // this.$f7.popup('.EditAccountMember')
      loadPage(this, {url: '/accountMembers/accountMemberDetail/'})
    },
    editAccountMemberMobile (data) {
      this.$engine.settings.set({currentAccountMember: data})
      // var formData = {
      //   'login': data.login,
      //   'status': data.status
      // }
      // this.$f7.formFromData('#EditAccountMemberForm', formData)
      // this.$f7.popup('.EditAccountMember')
      loadPage(this, {url: '/accountMembers/edit/'})
    },
    removeAccountMemberWeb (data) {
      let that = this
      that.$f7.confirm('Do you really want to remove this account?', 'Remove Member', function () {
        var idAccountInList = -1
        var filteredListAccount = that.filteredUserAccounts
        for (var keys in filteredListAccount) {
          for (var account in filteredListAccount[keys]) {
            if (filteredListAccount[keys][account].id === data.id) {
              idAccountInList = account
              break
            }
          }
          if (idAccountInList !== -1) {
            filteredListAccount[keys].splice(idAccountInList, 1)
            break
          }
        }
        that.removeAccountMember(data)
      })
    },
    removeAccountMember (data) {
      let that = this
      this.$engine.settings.set({currentAccountMember: data})
      that.$engine.accounts
      .deleteUserFromAccount(that.$settings.currentAccountMember.id)
      .then(resp => {
        that.$f7.modal({
          title: 'Account deleted',
          text: '<span class="preloader"></span>'
        })
        setTimeout(function () {
          that.login = ''
          that.$f7.closeModal()
          // that.$bus.$emit('refresh-cache-account-members')
          loadPage(that, {url: '/accountMembers/', force: false, ignoreCache: false})
        }, 2000)
      })
      .catch(err => {
        this.handleError(err) // mixins errorHandlerMixins
      })
    },
    isEmpty (map) {
      for (var key in map) {
        if (map.hasOwnProperty(key)) {
          return false
        }
      }
      return true
    }
  }
}
</script>

<style scoped>
.content-block-title {
  margin: 15px 15px 10px
}
</style>



// WEBPACK FOOTER //
// CMAccountMembersList.vue?6e220e1c